import { Product } from '../types';

export const products: Product[] = [
  {
    id: '1',
    name: 'Зоогумус',
    description: 'Экологичное удобрение улучшает почву и повышает урожайность',
    fullDescription: 'Зоогумус – биоорганическое удобрение для восстановления почвы и получения экологически чистого урожая. Подходит для овощей, ягодных кустарников, бахчевых, газонов, цветов, хвойных, рассады и декоративных растений. Применяется для корневой и внекорневой подкормки. Содержит полный комплекс микроэлементов, улучшает рост, повышает урожайность и сохраняемость плодов. Оздоровляет почву, подавляя патогены, улучшает структуру и аэрацию грунта. Экологичен, без химикатов и токсинов. Аминокислоты повышают устойчивость культур к стрессу, что особенно эффективно в суровых условиях климата.',
    price: 30,
    image: '/assets/images/products/zoogumus1.webp',
    images: [
      '/assets/images/products/zoogumus1.webp',
      '/assets/images/products/zoogumus2.webp',
      '/assets/images/products/zoogumus3.webp'
    ],
    features: [
      'Экологически чистый',
      'Улучшает урожайность',
      'Восстанавливает почву',
      'Содержит микроэлементы',
      'Повышает устойчивость'
    ],
    specifications: {
      'Вес упаковки': '0.5 кг',
      'pH': '6.5-7.5',
      'Азот (N)': '2.5%',
      'Фосфор (P)': '1.8%',
      'Калий (K)': '2.0%',
      'Органическое вещество': '45%',
      'Форма': 'Гранулы'
    },
    inStock: false,
    category: 'Удобрения',
    variants: [
      {
        id: '1-0.5',
        weight: '0.5 кг',
        price: 30,
        image: '/assets/images/products/zoogumus1.webp',
        images: [
          '/assets/images/products/zoogumus1.webp',
          '/assets/images/products/zoogumus2.webp',
          '/assets/images/products/zoogumus3.webp'
        ],
        inStock: false,
        description: 'Гранулированная форма',
        isConcentrated: false
      },
      {
        id: '1-15',
        weight: '15 кг',
        price: 900,
        image: '/assets/images/products/pocket1.webp',
        images: [
          '/assets/images/products/pocket1.webp',
          '/assets/images/products/pocket2.webp',
          '/assets/images/products/pocket3.webp'
        ],
        inStock: false,
        description: 'Концентрированный порошок',
        isConcentrated: true
      },
      {
        id: '1-20',
        weight: '20 кг',
        price: 1200,
        image: '/assets/images/products/pocket2.webp',
        images: [
          '/assets/images/products/pocket1.webp',
          '/assets/images/products/pocket2.webp',
          '/assets/images/products/pocket3.webp'
        ],
        inStock: false,
        description: 'Гранулированная форма',
        isConcentrated: false
      }
    ]
  },
  {
    id: '2',
    name: 'Прикормка для рыбы',
    description: 'Натуральная смесь надолго привлекает и удерживает рыбу',
    fullDescription: 'Прикормка для рыбы в наше время стала незаменимой для успешной рыбалки – это эффективный и натуральный способ привлечь улов. Наша смесь богата привлекательными веществами и ароматами, которые рыба любит, и идеально дополняет любую снасть, без раздражающих добавок, вызывающих отпугивание. В составе – все нужные компоненты для активного клева и долгого удержания рыбы в зоне. Без химии, красителей и ГМО: чистый продукт из Сибири. Смесь быстро растворяется в воде, усиливает привлекательность места, обеспечивает стабильный клев, обильный улов и удовольствие от процесса. Натуральный выбор для опытных рыбаков.',
    price: 1560,
    image: '/assets/images/products/fish1.webp',
    images: [
      '/assets/images/products/fish1.webp',
      '/assets/images/products/fish2.webp',
      '/assets/images/products/fish3.webp'
    ],
    features: [
      'Натуральный состав',
      'Быстро растворяется',
      'Усиливает клев',
      'Долго удерживает рыбу',
      'Без химии'
    ],
    specifications: {
      'Вес упаковки': '13 кг',
      'Время действия': '4-6 часов',
      'Температура хранения': '0-25°C',
      'Срок годности': '24 месяца'
    },
    inStock: false,
    category: 'Рыболовные товары',
    variants: [
      {
        id: '2-13',
        weight: '13 кг',
        price: 1560,
        image: '/assets/images/products/fish1.webp',
        images: [
          '/assets/images/products/fish1.webp',
          '/assets/images/products/fish2.webp',
          '/assets/images/products/fish3.webp'
        ],
        inStock: false,
        description: 'Стандартная упаковка'
      },
      {
        id: '2-20',
        weight: '20 кг',
        price: 2400,
        image: '/assets/images/products/pocket3.webp',
        images: [
          '/assets/images/products/pocket1.webp',
          '/assets/images/products/pocket2.webp',
          '/assets/images/products/pocket3.webp'
        ],
        inStock: false,
        description: 'Большая упаковка'
      }
    ]
  },
  {
    id: '3',
    name: 'Добавка в корма для домашних животных',
    description: 'Комплекс питательных веществ укрепляет здоровье и делает питомцев активными',
    fullDescription: 'Добавка к корму для кошек и собак – натуральный источник энергии и здоровья. Содержит комплекс витаминов и питательных веществ, необходимых для активной и долгой жизни питомцев. Не вызывает аллергии, не содержит красителей, ароматизаторов и ГМО. Улучшает пищеварение, укрепляет зубы и суставы, делает шерсть блестящей, кожу здоровой, а иммунитет крепким. Чистый продукт из Сибири – лучший выбор заботливых хозяев.',
    price: 2100,
    image: '/assets/images/products/pets1.webp',
    images: [
      '/assets/images/products/pets1.webp',
      '/assets/images/products/pets2.webp',
      '/assets/images/products/pets3.webp'
    ],
    features: [
      'Улучшает пищеварение',
      'Укрепляет иммунитет',
      'Делает шерсть блестящей',
      'Натуральный продукт',
      'Без аллергенов'
    ],
    specifications: {
      'Вес упаковки': '3.2 кг',
      'Возраст животных': 'От 1 года',
      'Дозировка': '1 ч.л. на 10 кг веса',
      'Курс приема': '30 дней'
    },
    inStock: false,
    category: 'Корма для животных',
    variants: [
      {
        id: '3-3.2',
        weight: '3.2 кг',
        price: 2100,
        image: '/assets/images/products/pets1.webp',
        images: [
          '/assets/images/products/pets1.webp',
          '/assets/images/products/pets2.webp',
          '/assets/images/products/pets3.webp'
        ],
        inStock: false,
        description: 'Стандартная упаковка'
      },
      {
        id: '3-20',
        weight: '20 кг',
        price: 12000,
        image: '/assets/images/products/pocket1.webp',
        images: [
          '/assets/images/products/pocket1.webp',
          '/assets/images/products/pocket2.webp',
          '/assets/images/products/pocket3.webp'
        ],
        inStock: false,
        description: 'Большая упаковка'
      }
    ]
  },
  {
    id: '4',
    name: 'Добавка в корма для с/х животных',
    description: 'Натуральная смесь укрепляет здоровье животных и повышает продуктивность',
    fullDescription: 'Добавка к корму для сельскохозяйственных животных – это натуральный источник витаминов, минералов и аминокислот, необходимых для роста, здоровья и высокой продуктивности. Она улучшает пищеварение, укрепляет иммунитет, повышает усвояемость корма и способствует быстрому набору массы, молочной и яйценоскости продуктивности. Продукт безопасен, не содержит красителей, ароматизаторов и ГМО, легко усваивается и подходит для крупного рогатого скота, свиней, овец, коз, лошадей и птицы. Регулярное использование делает животных более активными и выносливыми, улучшает состояние шерсти, кожи и костей, а также повышает выживаемость молодняка. Это сбалансированное дополнение к рациону, которое помогает сохранить здоровье поголовья и получить стабильные результаты в хозяйстве.',
    price: 5200,
    image: '/assets/images/products/pocket1.webp',
    images: [
      '/assets/images/products/pocket1.webp',
      '/assets/images/products/pocket2.webp',
      '/assets/images/products/pocket3.webp'
    ],
    features: [
      'Ускоряет рост',
      'Повышает продуктивность',
      'Легко усваивается',
      'Укрепляет здоровье',
      'Без ГМО'
    ],
    specifications: {
      'Вес упаковки': '1 кг',
      'Тип животных': 'КРС, свиньи, птица',
      'Дозировка': '50-100 г на 100 кг корма',
      'Курс приема': 'Постоянно'
    },
    inStock: false,
    category: 'Корма для животных'
  },
  {
    id: '5',
    name: 'БАДы для здоровья',
    description: 'Белки и витамины поддерживают иммунитет, энергию и долголетие',
    fullDescription: 'Наша продукция – источник белков, полиненасыщенных жирных кислот, аминокислот, витаминов, минералов и пищевых волокон. Она укрепляет иммунитет, снижает заболеваемость, поддерживает лечение, продлевает активное долголетие. Подходит мужчинам и женщинам, улучшает внешний вид: волосы становятся крепкими, ногти – прочными, кожа быстрее восстанавливается. Спортсменам добавка дает энергию и выносливость, людям умственного труда – снижает усталость. Пожилым помогает уменьшить боли в суставах, улучшить память и общее состояние. Это универсальная поддержка организма – ваша «батарейка» для здоровья.',
    price: 1100,
    image: '/assets/images/products/bla_premium1.webp',
    images: [
      '/assets/images/products/bla_premium1.webp',
      '/assets/images/products/bla_premium2.webp',
      '/assets/images/products/bla_premium3.webp'
    ],
    features: [
      'Укрепляет здоровье',
      'Повышает выносливость',
      'Поддерживает иммунитет',
      'Улучшает внешний вид',
      'Замедляет старение'
    ],
    specifications: {
      'Количество капсул': '60 шт',
      'Дозировка': '1-2 капсулы в день',
      'Курс приема': '30 дней',
      'Срок годности': '36 месяцев'
    },
    inStock: false,
    category: 'БАДы'
  }
];

export const getProductById = (id: string): Product | undefined => {
  return products.find(product => product.id === id);
};

export const getProductsInStock = (): Product[] => {
  const inStockProducts = products.filter(product => product.inStock);
  // Ставим БАДы (id: '5') на первое место
  const badIndex = inStockProducts.findIndex(product => product.id === '5');
  if (badIndex > 0) {
    const badProduct = inStockProducts.splice(badIndex, 1)[0];
    inStockProducts.unshift(badProduct);
  }
  // Ставим прикормку для рыбы (id: '2') на последнее место
  const fishIndex = inStockProducts.findIndex(product => product.id === '2');
  if (fishIndex >= 0 && fishIndex < inStockProducts.length - 1) {
    const fishProduct = inStockProducts.splice(fishIndex, 1)[0];
    inStockProducts.push(fishProduct);
  }
  return inStockProducts;
};

export const getRandomProducts = (excludeId?: string, count: number = 3): Product[] => {
  const filteredProducts = excludeId 
    ? products.filter(p => p.id !== excludeId)
    : products;
  
  const shuffled = [...filteredProducts].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};
